import { useRoute, useRouter } from 'vue-router'
import qs from '@halobear/utils/qs'
import vconsole from '@halobear/utils/vconsole'
import { isMyApp } from '@/utils/bridge'

export default () => {
  const route = useRoute()
  const router = useRouter()
  router.afterEach(() => {
    const { debug } = isMyApp ? qs.parse(window.location.href.split('#')[0]) : route.query
    if (debug) {
      vconsole.show()
    }
  })
  return { vconsole }
}